import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { Box, FlexDiv, FlexRowDiv, H3 } from 'components/generic/HomePageComponents'
import { ValuePropStylizedP } from './Styled'

const ValuePropCard = ({ item: { title, description, imageUrl } }) => (
  <FlexRowDiv
    maxWidth='560px'
    marginBottom='20px'
    mr={{ _: '10px', tablet: 0 }}
    ml={{ _: '15px', tablet: 0 }}
  >
    <Box
      bg='grey'
      borderRadius='50%'
      height={{ _: '60px', tablet: '70px', desktop: '80px' }}
      width={{ _: '60px', tablet: '70px', desktop: '80px' }}
      marginTop={{ _: '0px', tablet: '10px' }}
    >
      <GenericLazyLoadImage
        margin={{ _: '15px', tablet: '17.5px' }}
        src={imageUrl}
        width={{ _: '30px', tablet: '35px', desktop: '45px' }}
        textAlign='left'
        verticalAlign='middle'
        height={{ _: '30px', tablet: '35px', desktop: '45px' }}
      />
    </Box>
    <FlexDiv
      paddingLeft='20px'
      flexDirection='column'
      alignItems='start'
      justifyContent='start'
      maxWidth={{ _: '250px', tablet: '300px', desktop: '400px' }}
    >
      <H3
        marginTop='0px'
        marginBottom='5px'
        fontSize={{ _: '24px', tablet: '28px' }}
        textAlign='left'
      >
        {title}
      </H3>
      <ValuePropStylizedP
        textAlign='left'
        marginTop='0px'
        fontSize={{ _: '18px', tablet: '20px' }}
        lineHeight='1.3'
        maxWidth='400px'
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </FlexDiv>
  </FlexRowDiv>
)

export default ValuePropCard
